"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyDelegationNoPwRequestRequest = void 0;
var ApplyDelegationNoPwRequestRequest = /** @class */ (function () {
    function ApplyDelegationNoPwRequestRequest() {
    }
    return ApplyDelegationNoPwRequestRequest;
}());
exports.ApplyDelegationNoPwRequestRequest = ApplyDelegationNoPwRequestRequest;
;
//# sourceMappingURL=applyDelegationNoPwRequest.request.js.map